import { Kayttaja } from '../../model/kayttaja'
import { Selvityspyynto } from '../../model/selvitettavat'

export type SelvityspyynnonNakyvyydenKayttaja = Pick<Kayttaja, 'selvitettavienNakyvyys' | 'tositteenMaksutavat'>

export const onSelvityspyyntoNakyvissaKayttajalle = (kayttaja: SelvityspyynnonNakyvyydenKayttaja, selvityspyynto: Pick<Selvityspyynto, 'maksutapa'>): boolean => {
  if (kayttaja.selvitettavienNakyvyys !== 'omat') {
    return true
  }
  const maksutapa = selvityspyynto.maksutapa
  // Maksutavaton pyyntö ei kuulu kenenkään omiin, joten piilottaminen jättäisi sen kaikilta "omat"-käyttäjiltä näkemättä.
  if (typeof maksutapa !== 'number' || !Number.isFinite(maksutapa)) {
    return true
  }
  return (kayttaja.tositteenMaksutavat ?? []).some(tositteenMaksutapa => tositteenMaksutapa.tunniste === maksutapa)
}
